module.exports = __webpack_public_path__ + "static/6p-1-cb7a1eebee77323f78a7036347cc9ad3.jpg";